import gql from 'graphql-tag';

export const UPDATE_AD_SETS_BUDGET_BID = gql`
  mutation UpdateAdSetsBudgetMutation($ids: [ID!]!, $dailyBudget: Float, $actionsBid: Float) {
    updateAdSetsBudget(ids: $ids, dailyBudget: $dailyBudget, actionsBid: $actionsBid) {
      adSets {
        id
        dailyBudget
        actionsBid
      }
      errors
    }
  }
`;
